<div style="padding:10px;">
	<div style="font-weight:bolder; text-align:center; font-size:larger; margin-bottom:30px;">
		Looks like you have stopped exploring. You will be logged out momentarily, or choose to continue your session
	</div>
	<table style="width:100%; table-layout:fixed;">
		<tr>
			<td style="width:10%"></td>
			<td>
				<div class="progress" style="height: 20px; background-color:silver; text-align:center;">
					<div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" attr.aria-valuemax="{{warningDuration}}" [ngStyle]="{width: percent + '%'}">{{warningProgress}}/{{warningDuration}} seconds</div>
				</div>
				<div class="row" style="margin:20px 0px 20px 0px; text-align:center;">
					<div class="col-6">
						<button (click)="logout();" class="btn btn-outline-primary" style="width:110px;">Logout</button>
					</div>
					<div class="col-6">
						<button (click)="stayActive();" class="btn btn-primary" style="width:110px;">Stay Active</button>
					</div>
				</div>
			</td>
			<td style="width:10%"></td>
		</tr>
	</table>
</div>
